import React from 'react';
import {ClassName, ContainerBox, CustomTooltip, ReferenceTitle, SubTitle, ImagesContainer} from '../Style/ReferenceDisplay.style';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import {IMAGE_ITEMS_MOCK_FUNC} from '../../ManualRefinementImageList/Config/ManualRefinementImageList.constants';
import {ImageListItem, Box} from '../../../ui-library';
import {ImageUrl} from '../../ImageUrl';
import ImageModalView from '../../ImageModalView/View/ImageModalView.view';
import useImageModalView from '../../ImageModalView/Controller/useImageModalView.controller';
import utilService from '../../../services/utilService';
import {MAX_LEN_CLASS_NAME} from '../Config/ReferenceDisplay.constants';

const ReferenceDisplay = ({manualRefinementState}) => {
    const imageArray = manualRefinementState.referenceImages.length > 0 ? manualRefinementState.referenceImages : IMAGE_ITEMS_MOCK_FUNC(3);
    const {originalStr, isSliced, shortStr} = utilService.normalizedStingWithReturn(manualRefinementState.classes[manualRefinementState.index].name, MAX_LEN_CLASS_NAME);
    const {open,
        setOpen,
        activeHover,
        setActiveHover,
        setCurrentImageIndex,
        currentImageIndex} = useImageModalView();

    return (
        <ContainerBox>
            <ImageModalView
                imageList={imageArray}
                setOpen={setOpen}
                open={open}
                currentImageIndex={currentImageIndex}
            />
            <SubTitle>{`Class ${manualRefinementState.index + 1}/${manualRefinementState.classes.length}`}</SubTitle>
            {isSliced ? <CustomTooltip title={originalStr} placement='top'>
                <Box>
                    <ClassName>
                        {shortStr}
                    </ClassName>
                </Box>
            </CustomTooltip> : <ClassName>
                {originalStr}
            </ClassName>
            }
            <ReferenceTitle>{_SYSTEM_TITLES.referenceImages}</ReferenceTitle>
            <ImagesContainer>
                {imageArray.map((img, i) => (
                    <ImageListItem key={i}>
                        <ImageUrl
                            img={img}
                            isAspectRatio={true}
                            onMouseOver={() => setActiveHover(i)}
                            onMouseLeave={() => setActiveHover(-1)}
                            isHover={activeHover === i}
                            setOpen={setOpen}
                            setCurrentImageIndex={setCurrentImageIndex}
                            imageIndex={i}
                            fromreferenceinmr={true}
                            isMoveMode={manualRefinementState.isMoveToAnotherClass}/>
                    </ImageListItem>
                ))}
            </ImagesContainer>
        </ContainerBox>
    );
};

export default ReferenceDisplay;
